import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {
  AbstractControl,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {FacilityService, OrganizationService,} from '../../../apiModule1';
import {map, startWith} from 'rxjs/operators';
import {combineLatest, Observable, of} from "rxjs";
import {AsyncPipe} from '@angular/common';

// export function foundOrganizationValidator(organizations: Organization[]): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     const found = organizations.find(v=>v.name.toLowerCase() === control.value.toLowerCase());
//     return found ? null : {notfound: control.value};
//   };
// }


@Component({
  selector: 'pas-dialog-facility',
  standalone: true,
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss', '../../index-entity/dialog/dialog.component.scss', '../../index-entity/filling-method/filling-method.component.scss'],
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatOption,
    ReactiveFormsModule,
    MatIcon,
    MatIconButton,
    MatButton,
    MatAutocompleteTrigger,
    MatAutocomplete,
    AsyncPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent implements OnInit {

  private foundOrganizationValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const found = this.balanceHolders.find(v => v.name.toLowerCase() === control.value.toLowerCase());
      return found ? null : {notfound: control.value};
    };
  }

  isNew: boolean = false;

  balanceHolders: Organization[] = [];
  filteredOptions$: Observable<string[]> = of([]);

  form = this.fb.group({
    balanceHolder: ['', [Validators.required, this.foundOrganizationValidator()]],
    name: [this.data['name'] || '', [Validators.required]],
    egipRegistryNumber: [this.data['egipRegistryNumber'] || '', [Validators.required]],
    facilityAddress: [this.data['facilityAddress'] || '', [Validators.required]],

  })
  isEnabled: boolean = false;
  openedField = signal(false);


  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Record<string, any>,
    public dataService: FacilityService,
    private organizationService: OrganizationService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
  ) {
    this.isNew = data['isNew'];
    console.log('isNew', this.isNew, this.data);

    if (!this.isNew) {
      combineLatest([
        this.organizationService.apiOrganizationGet({pageIndex: 0,  pageSize: 1e6})
          .pipe(map(v => v.values)),
        (this.dataService as any)['apiFacilityIdGet']({id: this.data['id']})
      ]).subscribe((res) => {
        const [bhs, currentFacility] = res as unknown as [Organization[], Facility];
        this.balanceHolders = bhs

        currentFacility.name && this.form.get('name')!.setValue(currentFacility.name);
        currentFacility.iasId && this.form.get('egipRegistryNumber')!.setValue(currentFacility.egipRegistryNumber + '');
        currentFacility.facilityAddress && this.form.get('facilityAddress')!.setValue(currentFacility.facilityAddress);
        this.form.get('balanceHolder')!.setValue(currentFacility.balanceHolder.name, {emitEvent: false});
        this.setFilterOptions();

        this.cdr.markForCheck();
      })
    } else {
      this.organizationService.apiOrganizationGet({pageIndex: 0, pageSize: 1e6})
        .pipe(map(v => v.values))
        .subscribe((res) => {
          this.balanceHolders = res;
          this.setFilterOptions()
        })
    }

  }

  setFilterOptions() {
    this.filteredOptions$ = this.form.get('balanceHolder')!.valueChanges
      .pipe(
        startWith(''),
        map(value => {
          if (this.form.get('balanceHolder')!.valid) {
            return this.balanceHolders.map(balanceHolder => balanceHolder.name)
          }
          if(value === '') {
            return this.balanceHolders.map(balanceHolder => balanceHolder.name);
          }
          return this.balanceHolders.filter(balanceHolder => {
            return balanceHolder.name.toLowerCase().includes((value || '').toLowerCase())
          }).map(balanceHolder => balanceHolder.name);
        }),
      );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  _balanceHolderNameToOrganization(name: string | null): Organization | null {
    if (!name) return null
    return this.balanceHolders.find(v => v.name === name) || null;
  }

  onApply() {
    if (this.form.invalid) return;
    this.dialogRef.close({
      ...this.form.value,
      balanceHolder: this._balanceHolderNameToOrganization(this.form.get('balanceHolder')!.value)
    });
  }

  ngOnInit() {
    this.form.get('egipRegistryNumber')!.valueChanges.subscribe(value => {
      if (value === null || value === '0') {
        this.form.get('egipRegistryNumber')!.setValue('', {emitEvent: false});
      }
      const numberFilter = (value || '').toString().replace(/[^0-9]/g, '')
      this.form.get('egipRegistryNumber')!.setValue(numberFilter, {emitEvent: false});
    });


  }

  displayFn(balanceHolder: Organization): string {
    return balanceHolder && balanceHolder.name ? balanceHolder.name : '';
  }


  clearBalanceHolder() {
    this.form.get('balanceHolder')!.setValue('');
  }
}

